import Trix from "trix"

// The editor behind a `rich` spot template slot (VOR-18).
//
// Allowed are bold, italic, underline, bullet list, numbered list and line
// break. Everything else — headings, quotes, code, links, attachments — is taken
// out of the toolbar here and filtered again on the server, because a toolbar is
// convenience and never the rule (VOR-19, SpotTemplate::RichText).
const ALLOWED_ATTRIBUTES = ["bold", "italic", "underline", "bullet", "number"]

// Underline is not one of Trix's defaults.
Trix.config.textAttributes.underline = { tagName: "u", inheritable: true }

// Pictures reach the layout through image placeholders, not through the editor.
document.addEventListener("trix-file-accept", (event) => event.preventDefault())

document.addEventListener("trix-initialize", (event) => {
  const toolbar = event.target.toolbarElement
  if (!toolbar) return

  toolbar.querySelectorAll("[data-trix-attribute]").forEach((button) => {
    if (!ALLOWED_ATTRIBUTES.includes(button.dataset.trixAttribute)) button.remove()
  })
  toolbar.querySelectorAll("[data-trix-action='attachFiles']").forEach((button) => button.remove())
  toolbar.querySelectorAll(".trix-button-group--file-tools, [data-trix-dialog]").forEach((group) => group.remove())

  addUnderlineButton(toolbar)
})

// Cloned off the italic button so it inherits whatever Trix styles that one.
// Its face is the letter itself rather than a translated title — this file is
// the one place the app cannot reach `t()` from.
function addUnderlineButton(toolbar) {
  const italic = toolbar.querySelector("[data-trix-attribute='italic']")
  if (!italic || toolbar.querySelector("[data-trix-attribute='underline']")) return

  const underline = italic.cloneNode(true)
  underline.dataset.trixAttribute = "underline"
  underline.dataset.trixKey = "u"
  underline.className = "trix-button trix-button--icon"
  underline.textContent = "U"
  underline.style.textDecoration = "underline"
  italic.insertAdjacentElement("afterend", underline)
}
